/* Tutorial players keep their state scoped to the native section instance. */
(() => {
  'use strict';
  if (window.NarwalTutorials) { window.NarwalTutorials.init(document); return; }
  const states = new Map();

  function setup(section) {
    if (states.has(section)) return;
    const dialog = section.querySelector('dialog');
    const player = section.querySelector('.nwb-tutorials__player');
    if (!dialog || !player) return;
    const events = new AbortController();
    let trigger = null, oldOverflow = '', active = false;

    function cleanup(restoreFocus = true) {
      player.querySelectorAll('video').forEach(video => video.pause());
      player.replaceChildren();
      if (!active) return;
      active = false;
      document.documentElement.style.overflow = oldOverflow;
      if (restoreFocus && trigger?.isConnected) trigger.focus();
    }
    section.addEventListener('click', event => {
      const button = event.target.closest('[data-video]');
      if (!button || !section.contains(button) || active || !button.dataset.video) return;
      trigger = button;
      const src = button.dataset.video;
      let media;
      if (/youtube(?:-nocookie)?\.com\/embed\//.test(src)) {
        media = document.createElement('iframe');
        media.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
        media.allow = 'autoplay; encrypted-media; picture-in-picture';
        media.allowFullscreen = true;
        media.title = button.getAttribute('aria-label') || 'Обучающее видео';
      } else {
        media = document.createElement('video');
        media.src = src;
        media.controls = true;
        media.autoplay = true;
        media.playsInline = true;
      }
      player.replaceChildren(media);
      oldOverflow = document.documentElement.style.overflow;
      active = true;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
    }, { signal: events.signal });
    dialog.querySelector('.nwb-tutorials__close')?.addEventListener('click', () => dialog.close(), { signal: events.signal });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }, { signal: events.signal });
    dialog.addEventListener('close', () => cleanup(), { signal: events.signal });
    states.set(section, {
      destroy() {
        if (dialog.open) dialog.close();
        cleanup(false);
        events.abort();
        states.delete(section);
      }
    });
  }

  function init(scope) {
    if (scope.matches?.('[data-nwb-tutorials]')) setup(scope);
    scope.querySelectorAll('[data-nwb-tutorials]').forEach(setup);
  }
  window.NarwalTutorials = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, state] of states) if (event.target.contains(section)) state.destroy();
  });
})();
